import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import {
  withRouter, Switch, Route, Redirect,
} from 'react-router';
import urljoin from 'url-join';
import axios from 'axios';
import { API_URL, advancedSearchFilterOrder } from 'config.jsx';
import Search from 'components/search/Search';
import Lifeline from 'components/lifeline/Lifeline';
import Familytree from 'components/familytree/Familytree';
import Overview from 'components/overview/Overview';
import HealthGraph from 'components/health-graph/HealthGraph';
import Paper from '@material-ui/core/Paper';
import Loading from './Loading';
import ErrorMessage from './ErrorMessage';
import InfoBar from './top-panel/InfoBar';
import NavBar from './top-panel/NavBar';
import ExpandableLogbook from './logbook/ExpandableLogbook';
import withElephant from './withElephant/withElephant';
import ComponentErrorBoundary from './ComponentErrorBoundary';

const styles = {
  mainLayoutClass: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    fontFamily: 'Encode Sans Condensed !important',
    backgroundSize: 'cover',
    overflow: 'hidden',
  },
  componentWrapper: {
    position: 'relative',
    textAlign: 'center',
    height: '100%',
    width: '100%',
  },
  componentContent: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    height: '100%',
    width: '100%',
  },
  logbook: {},
};

export class MainLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focusedDate: null,
      logbookExpanded: false,
      measureSelectionExpanded: true,
      searchAttributes: [
        {
          field_name: 'num',
          params: ['value'],
          form_input_type: 'number',
        },
      ],
    };
    this.changeElephant = this.changeElephant.bind(this);
    this.toggleLogbookExpanded = this.toggleLogbookExpanded.bind(this);
    this.toggleMeasureSelectionExpanded = this.toggleMeasureSelectionExpanded.bind(this);
    this.setFocusedDate = this.setFocusedDate.bind(this);
  }

  componentDidMount() {
    axios.get(`${API_URL}search/fields/`)
      .then((response) => {
        this.setState({ searchAttributes: this.setSearchFilterOrder(response.data) });
      });
  }

  setSearchFilterOrder(filters) {
    const newFilters = [];
    const nonListedFilters = [];
    filters.forEach((filter) => {
      const indexOfFilter = advancedSearchFilterOrder.indexOf(filter.field_name);
      if (indexOfFilter !== -1) newFilters[indexOfFilter] = filter;
      else nonListedFilters.push(filter);
    });

    return newFilters.concat(nonListedFilters);
  }

  setFocusedDate(date) {
    this.setState({ focusedDate: date });
  }

  changeElephant(newElephantId) {
    const { history, elephant } = this.props;
    if (!elephant || newElephantId !== elephant.pk) history.push(`/elephant/${newElephantId}/overview`);
  }

  toggleLogbookExpanded(logbookExpanded) {
    const { measureSelectionExpanded } = this.state;
    if (measureSelectionExpanded === true) {
      this.setState({ logbookExpanded, measureSelectionExpanded: false });
    }
    this.setState({ logbookExpanded });
  }

  toggleMeasureSelectionExpanded(measureSelectionExpanded) {
    const { logbookExpanded } = this.state;
    if (logbookExpanded === true) {
      this.setState({ logbookExpanded: false, measureSelectionExpanded });
    }
    this.setState({ measureSelectionExpanded });
  }

  render() {
    const {
      classes: {
        topPanel, mainLayoutClass, componentWrapper, componentContent,
      },
      elephant, loading, networkError, withElephant: isWithElephant,
      match, advancedSearchFilters, searchParameter, searchResult, currentPage,
      setSearchResult, setCurrentPage, usingAdvancedSearch, setUsingAdvancedSearch,
      setAdvancedSearchFilters, setSearchParameter,
    } = this.props;

    const {
      logbookExpanded, focusedDate, searchAttributes, measureSelectionExpanded,
    } = this.state;
    const componentSwitch = (
      isWithElephant
        ? (
          <Switch>
            <Route
              path={urljoin(match.url, 'search')}
              render={() => (
                <Search
                  setActiveElephant={this.changeElephant}
                  searchAttributes={searchAttributes}
                  advancedSearchFilters={advancedSearchFilters}
                  setAdvancedSearchFilters={setAdvancedSearchFilters}
                  searchResult={searchResult}
                  setSearchResult={setSearchResult}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  usingAdvancedSearch={usingAdvancedSearch}
                  setUsingAdvancedSearch={setUsingAdvancedSearch}
                  searchParameter={searchParameter}
                  setSearchParameter={setSearchParameter}
                />
              )}
            />
            {loading && <Route component={Loading} />}
            {(networkError || !elephant) && (
              <Route render={() => <ErrorMessage error={networkError} />} />
            )}
            <Route path={urljoin(match.url, 'overview')} render={() => (<Overview elephant={elephant} />)} />
            <Route path={urljoin(match.url, 'pedigree')} render={() => (<Familytree activeElephant={elephant} nodeClick={this.changeElephant} />)} />
            <Route
              path={urljoin(match.url, 'measures')}
              render={() => (
                <HealthGraph
                  measureCodes={elephant.measureCodes}
                  elephantId={elephant.pk}
                  focusedDate={focusedDate}
                  setFocusedDate={this.setFocusedDate}
                  logbookExpanded={logbookExpanded}
                  measureSelectionExpanded={measureSelectionExpanded}
                  toggleMeasureSelectionExpanded={this.toggleMeasureSelectionExpanded}
                />
              )}
            />
            <Route
              path={urljoin(match.url, 'lifeline')}
              render={() => (
                <Lifeline
                  elephant={elephant}
                  focusedDate={focusedDate}
                  onDateSelected={this.setFocusedDate}
                  onElephantSelected={this.changeElephant}
                  logbookIsExpanded={logbookExpanded}
                />
              )}
            />
            <Redirect to={urljoin(match.url, 'overview')} />
          </Switch>
        )
        : (
          <Switch>
            <Route
              path={urljoin(match.url, 'search')}
              render={() => (
                <Search
                  setActiveElephant={this.changeElephant}
                  searchAttributes={searchAttributes}
                  advancedSearchFilters={advancedSearchFilters}
                  setAdvancedSearchFilters={setAdvancedSearchFilters}
                  searchResult={searchResult}
                  setSearchResult={setSearchResult}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  usingAdvancedSearch={usingAdvancedSearch}
                  setUsingAdvancedSearch={setUsingAdvancedSearch}
                  searchParameter={searchParameter}
                  setSearchParameter={setSearchParameter}
                />
              )}
            />
            <Redirect to={urljoin(match.url, 'search')} />
          </Switch>
        ));

    return (
      <div className={mainLayoutClass}>
        <Paper className={topPanel}>
          <InfoBar elephant={elephant} recentsClick={this.changeElephant} />
          <NavBar onlySearch={!isWithElephant} />
        </Paper>
        <div className={componentWrapper}>
          <ComponentErrorBoundary>
            <div className={componentContent}>
              {componentSwitch}
            </div>
          </ComponentErrorBoundary>
        </div>
        {withElephant && elephant && (
          <ExpandableLogbook
            logbookRef={this.logbookRef}
            elephantId={elephant.pk}
            focusedDate={focusedDate}
            onDateFocused={this.setFocusedDate}
            toggleLogbookExpanded={this.toggleLogbookExpanded}
            expanded={logbookExpanded}
          />
        )}
      </div>
    );
  }
}

MainLayout.defaultProps = {
  history: {},
  elephant: null,
  loading: null,
  networkError: {},
  withElephant: false,
  usingAdvancedSearch: false,
};

MainLayout.propTypes = {
  classes: PropTypes.shape().isRequired,
  match: PropTypes.shape().isRequired,
  history: PropTypes.shape(),
  elephant: PropTypes.shape(),
  loading: PropTypes.bool,
  networkError: PropTypes.shape(),
  withElephant: PropTypes.bool,
  advancedSearchFilters: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  searchParameter: PropTypes.string.isRequired,
  searchResult: PropTypes.shape().isRequired,
  setSearchResult: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  usingAdvancedSearch: PropTypes.bool,
  setUsingAdvancedSearch: PropTypes.func.isRequired,
  setAdvancedSearchFilters: PropTypes.func.isRequired,
  setSearchParameter: PropTypes.func.isRequired,
};

export default withRouter(withStyles(styles)(MainLayout));
const MainLayoutWithElephant = withElephant(withRouter(withStyles(styles)(MainLayout)));
export { MainLayoutWithElephant };



// WEBPACK FOOTER //
// ./src/layout/MainLayout.jsx